import './assets/index';
import MdPage from './index.vue';

export {
    MdPage,
};

export default MdPage;
